import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
import { Camera } from "./../../compoment/icon";
import { getPortraitViewportContainer } from "../../compoment/PortraitStage";

const Idle = () => {
  const navigate = useNavigate();
  const handleScanNow = () => {
    localStorage.removeItem("ticket_detail");
    navigate("/qr-scan", { state: { rescan: Date.now() } });
  };

  return (
    <>
      <section className="idleSection">

        {/* Background Video */}
        {createPortal(
          <div className="fullScreenVideo">
            <video className="backgroundVideo" autoPlay loop muted playsInline>
              <source src={"https://d2s4ngnid78ki4.cloudfront.net/assets/bg-vedio.mp4"} type="video/mp4" />
            </video>
            <div className="overlay" />
          </div>,
          getPortraitViewportContainer() ?? document.body
        )}

        {/* Foreground Content */}
        <div className="scanCard">
          <div className="heading">Digital Graffiti</div>
          <div className="tapTxt">
            Tap
            <span className="scanNow">
              {" "}
              <Camera /> Scan QR Code
            </span>{" "}
            to use the kiosk
          </div>

          <div>
            <button className="btnScanNow" onClick={handleScanNow}>
              <span>
                <Camera />
              </span>{" "}
              Scan QR Code
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Idle;
